import { ExternalDmvStatus, StatusType } from "@Types/title_issues";

export const buildDmvStatusQuery = (status: ExternalDmvStatus) => {
  return {
    "data.info.dmvInfo.status":
      status === "Titled"
        ? "titled"
        : status === "Not checked"
        ? "not_checked"
        : { $in: ["error", "old_title", "untitled", "not_supported"] },
  };
};

export const buildDocumentStatusQuery = (
  status: StatusType | "incomplete"
) => {
  const baseFields = [
    "data.info.oldTitleRegistrationInfo.status",
    "data.info.titleRegistrationInfo.status",
    "data.info.receiptInfo.status",
  ];

  switch (status) {
    case "resolved":
      return baseFields.reduce(
        (query, field) => ({
          ...query,
          [field]: status,
        }),
        {}
      );
    case "awaiting":
      return {
        $and: [
          {
            "data.info.dmvInfo.status": { $ne: "titled" },
          },
          ...baseFields.map((field) => ({
            [field]: "awaiting",
          })),
        ],
      };

    case "incomplete":
      return {
        $and: [
          ...baseFields.map((field) => ({
            [field]: { $in: ["awaiting", "resolved"] },
          })),
          {
            $or: baseFields.map((field) => ({ [field]: "resolved" })),
          },
          {
            $or: baseFields.map((field) => ({ [field]: "awaiting" })),
          },
        ],
      };

    default:
      return {};
  }
};
